import { SET_CREATE_TRANSACTION_RESPONSE_OBJ } from "../action";

export function setCreateTransactionResponseObj(responseData) {
  return (dispatch) => {
    dispatch({
      type: SET_CREATE_TRANSACTION_RESPONSE_OBJ,
      payload: { responseData },
    });
  };
}
